import React, { useEffect, useState } from "react";
import style from "./donation.module.css";
import { Col, Form, ProgressBar, Row } from "react-bootstrap";
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";
import VideoPlayer from "../../modals/videoPlayer/VideoPlayer";
import ShareModal from "../../modals/share/ShareModal";
import useShareModal from "../../hooks/useShareModal";
import ReactMarkdown from "react-markdown";

// import searchCenter from"../searchcenter/SearchCenter";

// import { fileBaseUrl } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import {
  oneTimePayment,
  createSubscription,
  getRecentTransaction,
  AdminPayment,
  createAdminSubscription,
} from "../../apis/paymentApis";
import { useDispatch } from "react-redux";
import { getToken } from "../../utils/api";
import { toast } from "react-toastify";
import TransactionStatus from "../../modals/transaction/TransactionStatu";
import { getCenterById, getComments } from "../../apis/CenterApis";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { paypalPayment } from "../../apis/paymentApis";
import {
  getTotalTransactionandPercentage,
  fetchConnectedAccount,
} from "../../apis/paymentApis";
import useGetUser from "../../customHook/useGetUser";
import { jwtDecode } from "jwt-decode";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { baseUrl } from "../../utils/api";


import Pray from "./pray";

// const PAYPAL_PLAN_IDS = {
//   "40": "P-40_MONTHLY_PLAN_ID",
//   "50": "P-50_MONTHLY_PLAN_ID",
//   "70": "P-70_MONTHLY_PLAN_ID",
//   "100": "P-100_MONTHLY_PLAN_ID",
//   "200": "P-200_MONTHLY_PLAN_ID",
// };

const Donation = () => {
  const token = getToken();
  const [searchParams] = useSearchParams();
  useGetUser();
  const location = useLocation();

  const dispatch = useDispatch();
  const [centerData, setCenterData] = useState(null);
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  // const [isdata, setIsData] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [showTextArea, setShowTextArea] = useState(false);
  const [fullName, setFullName] = useState("");
  const [showTransactionStatus, setShowTransactionStaus] = useState(false);
  const [donationList, setDonationList] = useState(null);
  const [centerDetail, setCenterDetail] = useState();
  const [usercomment, setUserComment] = useState("");
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState();
  const [centerid, setCenterId] = useState(null);
  const [sendInvoiceConsent, setSendInvoiceConsent] = useState(false);
  const [churchGroups, setChurchGroups] = useState([]);
  // const [shareText, setShareText] = useState("");
  // const [aiTitle, setAiTitle] = useState("");
  // const [isLoadingShare, setIsLoadingShare] = useState(false);
  const { slug } = useParams();

  const resolveSlug = async () => {
    const res = await axios.get(`${baseUrl}/admin/byslug/${slug}`);
    console.log("res", res)
    setCenterId(res.data._id);
    localStorage.setItem("centerId", res.data._id);
  };

  useEffect(() => {
    resolveSlug();
  }, [slug]);
  const isHTML = (text) => /<\/?[a-z][\s\S]*>/i.test(text);

  useEffect(() => {
    if (centerData?._id && centerData?.campaignType === "Church") {
      axios
        .get(`${baseUrl}/admin/groupslugname/${centerData._id}`)
        .then((res) => {
          setChurchGroups(res.data);
        });
    }
  }, [centerData]);


  const navigate = useNavigate();
  const { isOpen: showShareModal, shareConfig, openShareModal, closeShareModal } = useShareModal();
  const fetchRecentTransaction = (id) => {
    if (id) {
      dispatch(getRecentTransaction({ id: centerid })).then((res) => {
        if (res?.transactions) setDonationList(res.transactions);
      });
    }
  };

  // const openShareWithAI = async () => {
  //   setIsLoadingShare(true);

  //   const cleanUrl = window.location.href.split("?")[0];

  //   try {
  //     const { data } = await axios.post(`${baseUrl}/admin/socialmedia`, { url: cleanUrl });

  //     const resultText = data?.title && data?.description
  //       ? `${data.title}\n\n${data.description}\n\n${cleanUrl}`
  //       : cleanUrl;

  //     console.log("result", resultText)
  //     setAiTitle(data?.title || "");
  //     setShareText(resultText);

  //     setIsLoadingShare(false);

  //     // 🔥 pass the fresh data directly here
  //     openShareModal({
  //       shareUrl: cleanUrl,
  //       title: data?.title || centerData?.centerName,
  //       description: data?.description || centerData?.centerDescription || "",
  //       hashtags: ["FundLife", "Donation", "Charity"]
  //     });

  //   } catch (err) {
  //     console.log("AI error:", err);
  //     setIsLoadingShare(false);

  //     // fallback open modal
  //     openShareModal({
  //       shareUrl: cleanUrl,
  //       title: centerData?.centerName,
  //       description: cleanUrl,
  //       hashtags: ["FundLife", "Donation"]
  //     });
  //   }
  // };




  // const handleShare = async () => {
  //   openShareWithAI();

  // };

  useEffect(() => {
    const success = searchParams.get("success");
    if (success === "true") {
      setShowTransactionStaus(true);
    }
  }, [searchParams]);


  useEffect(() => {
    if (
      searchParams.get("openShare") === "true" &&
      centerData
    ) {
      const cleanUrl = window.location.href.split("?")[0];
      console.log(centerData, "centrdata.....")
      openShareModal({
        shareUrl: cleanUrl,
        title: centerData.centerName,
        description: centerData.description,
        pageId: centerData._id
      });
    }
  }, [searchParams, centerData]);


  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   if (params.get("openShare") == "true") {
  //     const cleanUrl = window.location.href.split("?")[0];

  //     console.log("Cemetrdata",centerData)

  // openShareModal({
  //   shareUrl: cleanUrl,
  //    title:centerData.centerName,
  //   description:centerData.description
  // });
  //   }
  //   // if (params.get("openShare")== "true") {
  //   //   openShareModal({
  //   //     shareUrl:shareConfig.shareUrl,
  //   //     title:shareConfig.title,
  //   //     description:shareConfig.description,
  //   //     hashtags: shareConfig.hashtags
  //   //   });
  //   // }
  // }, []);

  const handleShare = () => {
    console.log(centerData, "centrdata.....")
    const cleanUrl = window.location.href.split("?")[0];

    openShareModal({
      shareUrl: cleanUrl,
      title: centerData.centerName,
      description: centerData.description,
      pageId: centerData._id
    });
  };

  const shouldHideGreekLifeVideo = (campaignType, mediaUrl) => {
    if (!mediaUrl) return false;
    const isGreekLife = typeof campaignType === "string" && campaignType.toLowerCase() === "greeklife";
    const targetVideoUrl = "https://www.youtube.com/watch?v=3G3rnMfHtzg";
    const isTargetVideo = typeof mediaUrl === "string" && (
      mediaUrl.includes("3G3rnMfHtzg") ||
      mediaUrl.trim() === targetVideoUrl
    );
    return isGreekLife && isTargetVideo;
  };



  const filesData = (value) => {
    const fileExtension = value?.media?.split(".").pop().toLowerCase();
    const imageExtensions = ["jpg", "jpeg", "png", "gif"];
    const videoExtensions = ["mp4", "avi", "mov", "mkv"];
    const youtubePattern =
      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;

    if (shouldHideGreekLifeVideo(value?.campaignType, value?.media)) {
      value.type = "unsupported";
    } else if (imageExtensions.includes(fileExtension)) {
      value.type = "image";
    } else if (youtubePattern.test(value.media)) {
      value.type = "youtube";
    } else if (videoExtensions.includes(fileExtension)) {
      value.type = "video";
    } else {
      value.type = "unsupported";
    }

    return value;
  };

  // Extracting the ID manually from the pathname
  // const path = location.pathname;
  // const id = path.split("/").pop();

  useEffect(() => {
    console.log("loca", location.state)
    if (!centerid) return; // ⛔ STOP null calls

    axios.post(
      `${baseUrl}/admin/totalvist/${centerid}`
    );
    if (location.state) {
      fetchRecentTransaction(centerid);
      setCenterData(location.state);
    }
    if (!location.state) {
      console.log("enetr......location....")
      dispatch(getCenterById({ id: centerid })).then((res) => {
        if (res?.centerData) {
          fetchRecentTransaction(centerid);
          setCenterData(filesData(res?.centerData));
        }
      });
    }
    dispatch(getTotalTransactionandPercentage({ id: centerid })).then((res) => {
      if (res?.result) {
        setCenterDetail(res?.result);
      }
    });
    // setIsData(true);
  }, [centerid]);
  const [supportCampaignName, setSupportCampaignName] = useState(null);

  useEffect(() => {


    if (centerData?.campaignId) {
      const id = centerData?.campaignId;
      dispatch(getCenterById({ id })).then((res) => {
        if (res?.centerData) {
          setSupportCampaignName(res?.centerData?.centerName);
        }
      });
    }
  }, [centerData]);

  useEffect(() => {
    if (!centerid) return; // ⛔ STOP null calls

    dispatch(getComments({ id: centerid })).then((res) => {
      if (res) {
        console.log(res);
        setComments(res);
      }
    });
    // setIsData(true);
  }, [centerid]);

  useEffect(() => {
    if (!centerid) return; // ⛔ STOP null calls

    const fetchConnect = async () => {
      try {
        const accountData = await fetchConnectedAccount({ id: centerid });
        setConnectedAccount(accountData);
      } catch (err) {
        console.error("Error fetching connected account:", err);
      }
    };

    if (centerid) {
      fetchConnect();
    }
  }, [centerid]);
  const handleDateConversion = (dateTimeString) => {
    const dateObject = new Date(dateTimeString);
    const formattedDateTime = dateObject.toLocaleDateString();
    return formattedDateTime;
  };
  const handlePlay = (url) => {
    setVideoUrl(url);
    setShowVideoPlayer(true);
  };
  const [amount, setSelectedAmount] = useState(""); // State for the selected amount radio button
  const [selectedFrequency, setSelectedFrequency] = useState("month"); // State for the selected frequency radio button
  const [connectedAccount, setConnectedAccount] = useState(null);
  const [Id, setId] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleAmountChange = (e) => {
    setSelectedAmount(e.target.value); // Update the selected amount
  };
  // const handleNavigate = () => {
  //   navigate("/campaign-register")
  // }

  console.log("center", centerData)
  const handleNavigate = () => {
    navigate("/campaign-register", {
      state: {
        prefill: {
          campaignId: centerData?._id,
          // goalAmmount: centerData?.goalAmmount,
        }

      }
    });
  };

  const handleFrequencyChange = (e) => {
    setSelectedFrequency(e.target.value); // Update the selected frequency
  };

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      setId(decoded?.sub);
      setEmail(decoded?.email);
      setIsLoggedIn(true);
    }
  }, []);
  const handleDonate = () => {
    if (!amount) {
      toast.error("Please select a  amount for proceed the payment");
      return;
    }
    if (!email) {
      toast.error("Please enter the email address");
      return;
    }
    if (!fullName) {
      // ← ADD THIS
      toast.error("Please enter your full name");
      return;
    }

    const clearamount = amount.replace(/,/g, "");

    if (!isNaN(clearamount) && Number(clearamount) >= 0) {
      if (selectedFrequency === "1" && connectedAccount) {
        dispatch(
          oneTimePayment({
            amount: clearamount,
            centerId
              : centerData?._id
                ? centerData._id
                : centerData.id,
            usercomment: usercomment,
            email: email,
            fullName: fullName,
            _id: Id,
          })
        ).then((res) => {
          if (res?.data) {
            window.location.href = res?.data;
          }
        });
      } else if (selectedFrequency == "month" && connectedAccount) {
        dispatch(
          createSubscription({
            amount: amount,
            interval: "month",
            centerId: centerData?._id
              ? centerData._id
              : centerData.id,
            usercomment: usercomment,
            email: email,
            fullName: fullName,
            _id: Id,
          })
        ).then((res) => {
          if (res?.url) {
            window.location.href = res?.url;
          }
        });
      } else if (!connectedAccount && selectedFrequency === "1") {
        dispatch(
          AdminPayment({
            amount: amount,
            email: email,
            fullName: fullName,
            id: Id,
            centerId
              : centerData?._id
                ? centerData._id
                : centerData.id,
            usercomment: usercomment,
            sendInvoiceConsent: sendInvoiceConsent

          })
        ).then((res) => {
          if (res?.data) {
            window.location.href = res?.data;
          }
        });
      } else {
        dispatch(
          createAdminSubscription({
            amount: amount,
            interval: "month",
            email: email,
            fullName: fullName,
            id: Id,
            centerId
              : centerData?._id
                ? centerData._id
                : centerData.id,
            usercomment: usercomment,
            sendInvoiceConsent: sendInvoiceConsent

          })
        ).then((res) => {
          if (res?.url) {
            window.location.href = res?.url;
          }
        });
      }
    } else {
      toast.error("Invalid amount. Please enter a valid number.");
      return;
    }
  };

  // if (!isLoggedIn) {
  localStorage.setItem("email", email);
  localStorage.setItem("amount", amount);
  localStorage.setItem("fullName", fullName);

  // }

  function getYouTubeVideoId(url) {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }
  const handleClick = (data) => {
    console.log("dataasenter", data?.campaignName)
    // navigate(`/donation/${data.campaignId}`);/

    // Houston Pregnancy Help Center
    if (data?.campaignName == "5th ward") {
      window.open(
        "https://www.houstonpregnancyhelpcenter.org/",
        "_blank"
      );
      return;
    }

    // Waller Pregnancy Care Center
    if (data?.campaignName == "Waller Pregnancy Care Center") {
      window.open(
        "https://wtloutreach.com/waller-pregnancy-care-center/",
        "_blank"
      );
      return;
    }
    window.open(`/donation/${data.campaignSlugName}`, "_blank");

    localStorage.setItem("centerId", data.campaignId);
  };

  const handleOperating = () => {
    window.open("https://wtloutreach.com/waller-pregnancy-care-center/", "_blank");
  };
  const groupSubMap = {
    "Men Of Issachar": "(Men over 25)",
    "Naomi’s Circle": "(Women over 25)",
    "The Benjamites": "(Men 24 & under)",
    "The Ruth Generation": "(Women 24 & under)"
  };
  const isYouTubeUrl = (url) =>
    typeof url === "string" && url.includes("youtube.com");


  return (
    <>
      <Helmet>
        <title>
          {centerData?.id != "66f2a41ba8462a390b54d2b4" &&
            centerData?.centerName
            ? `Donation - ${centerData.centerName} -Fund Life`
            : "Donation - Janet -Fund Life"}
        </title>
        {/* <meta
          name="description"
          content="Join us in empowering women and families facing unplanned pregnancies. Your donation helps provide vital resources, support, and alternatives to abortion through our network of pregnancy care centers. Together, we can create a positive impact in our communities."
        />
        <meta
          property="og:description"
          content="Join us in empowering women and families facing unplanned pregnancies. Your donation helps provide vital resources, support, and alternatives to abortion through our network of pregnancy care centers. Together, we can create a positive impact in our communities."
        />
        <meta
          name="keywords"
          content="Mobile Medical Unit,Pregnancy Support,Alternatives to Abortion,Community Outreach,Health Essentials,Donation Campaign,Prenatal Care,Empowerment,Fundraising,Education"
        /> */}
      </Helmet>
      <div className={style.mainsection}>
        <div style={{ height: "80px" }} />
        <div className={style.donationcontainercamp}>
          <div className="container ">
            <div className={style.maindonation}>
              <div className={style.centername}>
                {centerData?.campaignType === "EndRecipientHBCU" &&
                  centerData?.centerName?.includes(" at ") ? (
                  <>
                    <div className={style.topLine}>
                      {centerData.centerName.split(" at ")[0]}
                    </div>

                    <div className={style.bottomLine}>
                      Save Her Seat at {centerData.centerName.split(" at ")[1]}
                    </div>
                  </>
                ) : (
                  centerData?.centerName
                )}
              </div>
              {/* <div className={`${style.centername}`}>
                {centerData?.centerName}
              </div> */}
              <div className={style.mainsupport}>
                {centerData?.campaignId && (
                  <div
                    className={style.insupport}
                    onClick={() => handleClick(centerData)}
                  >
                    {centerData?.campaignType == "EndRecipientHBCU"
                      ? "Operating Ministry Partner:"
                      : "In Support of:"}{" "}

                    <span className={style.linkLike}>
                      {supportCampaignName === "The HBCU Hope Project at PVAMU" ||
                        supportCampaignName === "The HBCU Hope Project at TSU"
                        ? "Save her Seat"
                        : supportCampaignName}
                    </span>
                  </div>
                )}
              </div>
              {!centerData?.campaignId && centerData?._id !== "69dc99ca4e9711a938acc38f" && centerData?.id !== "69dc99ca4e9711a938acc38f" && (
                <div className={style.centerLocation}>
                  {centerData?.address}, {centerData?.city} {centerData?.state}{" "}
                  {centerData?.country}
                </div>
              )}
              <Row>
                <Col md={12} xl={8} lg={12} className="p-0">
                  <div className={style.maincenterform}>
                    <div>
                      <div
                        className={`position-relative image-container ${style.mainvideocontainer}`}
                      >
                        {centerData?.type === "unsupported" && (
                          <img
                            className="w-100 h-100 "
                            src={`/defaultCenter.png`}
                            alt="center"
                          />
                        )}
                        {centerData?.type === "image" && (
                          <img
                            className="w-100 "
                            src={`${centerData?.media}`}
                            alt="center"
                          />
                        )}

                        {centerData?.type === "youtube" && (
                          <iframe
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                              centerData.media
                            )}`}
                            frameborder="0"
                            allow="encrypted-media"
                            allowfullscreen
                            title="video"
                            width="100%"
                            className={style.youtubevideo}
                          />
                        )}
                        {/* {centerData?.type === "video" && (
                          <video
                            controls
                            width="100%"
                            height="100%"
                            style={{ objectFit: 'cover' }}
                          >
                            <source src={centerData.media} type={`video/${centerData.media.split('.').pop()}`} />
                            Your browser does not support the video tag.
                          </video>
                        )} */}
                        {(centerData?.type === "youtube" || centerData?.type === "video") && (
                          <div
                            className={`overlay ${style.youvideo}`}
                            onClick={() => handlePlay(centerData?.media)}
                          ></div>
                        )}
                        {/* <div
                          class={`overlay ${style.youvideo}`}
                          onClick={() =>
                            (centerData?.type === "youtube" ||
                              centerData?.type === "video") &&
                            handlePlay(centerData?.media)
                          }
                        ></div> */}
                      </div>
                      <div className={style.donatedescription}>
                        {isHTML(centerData?.description) ? (
                          <div dangerouslySetInnerHTML={{ __html: centerData?.description }} />
                        ) : (
                          <ReactMarkdown>{centerData?.description || ""}</ReactMarkdown>
                        )}
                      </div>
                      {/* <div className={style.donatedescription}> */}
                      {/* <div dangerouslySetInnerHTML={{ __html: centerData?.description }} /> */}
                      {/* {centerData?.description} */}
                      {/* </div> */}
                      {centerData?.campaignMedia && centerData?.campaignName && !shouldHideGreekLifeVideo(centerData?.campaignType, centerData?.campaignMedia) && (
                        <div
                          className={`position-relative image-container ${style.mainvideocontainer}`}
                        >

                          {/* 🔹 YOUTUBE VIDEO */}
                          {isYouTubeUrl(centerData.campaignMedia) ? (

                            <iframe
                              src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                centerData.campaignMedia
                              )}`}
                              frameborder="0"
                              allow="encrypted-media"
                              allowfullscreen
                              title="video"
                              width="100%"
                              className={style.youtubevideo}
                            />



                          ) : (
                            /* 🔹 IMAGE */
                            <img
                              className="w-100"
                              src={centerData.campaignMedia}
                              alt="campaign"
                            />
                          )}

                          {/* 🔹 PLAY OVERLAY (only for video) */}
                          {isYouTubeUrl(centerData.campaignMedia) && (
                            <div
                              className={`overlay ${style.youvideo}`}
                              onClick={() => handlePlay(centerData.campaignMedia)}
                            ></div>
                          )}

                          {/* <p onClick={() => handleClick(centerData)}>{centerData?.campaignName}</p> */}

                        </div>

                      )}
                      {console.log(centerData?.campaignType, "campaignType")}
                      {centerData?.campaignType === "EndRecipientGeneral" ||
                        centerData?.campaignType === "EndRecipientHBCU" ? (
                        <p className={style.textendrecipitent}>
                          Your support makes this possible.
                        </p>
                      ) : centerData?.centerName === "HBCU Hope Project" ? null : (
                        /* <p
                          className={style.textoperating}
                          onClick={() => handleOperating()}
                        >
                          Operating Ministry:<span>Waller Pregnancy Care Center</span>
                        </p> */
                        null
                      )}
                      {/* {centerData?.campaignType != "EndRecipientGeneral" && centerData?.campaignType != "EndRecipientHBCU"  ?  (
                        <p className={style.textoperating} onClick={() => handleOperating()}>Operating Ministry:<span>Waller Pregnancy Care Center</span></p>
                      ) : (
                        <p className={style.textendrecipitent} > Your support makes this possible.</p>
                      )

                      } */}
                      {centerData?.campaignType === "Church" && churchGroups.length > 0 && (
                        <div className={style.groupbuttonmain}>
                          <p>Support Through a Church Group</p>

                          <div className={style.innergroupbutton}>
                            {churchGroups.map((group, index) => {
                              const shortName = group.centerName.split(" - ")[0];

                              return (
                                <button
                                  key={index}
                                  onClick={() =>
                                    window.open(`/donation/${group.slug}`, "_blank")
                                  }
                                >
                                  {shortName}
                                  <br />
                                  <span>
                                    {groupSubMap[shortName] || ""}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      {/* added s in GreekLife just for hiding the button temporary for all soroty campaign whose sampaignType is GreekLife */}
                      {centerData?.campaignType == "GreekLifes" && (
                        <div className={style.groupbuttonmain}>
                          <p>Support Through a Greek Group</p>
                          <div className={style.innergroupbutton}>
                            <button onClick={() =>
                              window.open("/donation/delta-sigma-theta-sorority-inc", "_blank")
                            }>Delta Sigma Theta</button>
                            <button onClick={() =>
                              window.open("/donation/zeta-phi-beta-sorority-inc", "_blank")
                            }>Zeta Phi Beta </button>
                          </div>
                          <div className={style.innergroupbutton2}>
                            <button onClick={() =>
                              window.open("/donation/sigma-gamma-rho-sorority-inc", "_blank")
                            }>Sigma Gamma Rho </button>
                            <button onClick={() =>
                              window.open("/donation/alpha-phi-alpha-fraternity-inc", "_blank")
                            }>Alpha Phi Alpha</button>
                          </div>

                          <div className={style.innergroupbutton2}>
                            <button onClick={() =>
                              window.open("/donation/kappa-alpha-psi-fraternity-inc", "_blank")
                            }>Kappa Alpha Psi</button>
                            <button onClick={() =>
                              window.open("/donation/omega-psi-phi-fraternity-inc", "_blank")
                            }>Omega Psi Phi</button>
                          </div>
                          <div className={style.innergroupbutton2}>
                            <button onClick={() =>
                              window.open("/donation/phi-beta-sigma-fraternity-inc", "_blank")
                            }>Phi Beta Sigma </button>
                            <button onClick={() =>
                              window.open("/donation/iota-phi-theta-fraternity-inc", "_blank")
                            }>Iota Phi Theta</button>
                          </div>
                          <div className={style.innergroupbutton2}>
                            <button onClick={() =>
                              window.open("/donation/alpha-kappa-alpha-sorority", "_blank")
                            }> Alpha Kappa Alpha</button>

                          </div>

                        </div>
                      )}

                      {/* {centerData?.centerName?.includes("The HBCU") && (
                        <div className="text-center mt-4 d-none d-lg-block">
                          <img
                            src="/donarcard.svg"   // <-- your custom image path
                            className="w-100"
                          />
                        </div>
                      )} */}
                    </div>
                  </div>
                </Col>
                <Col md={12} xl={4} lg={12}>
                  {(centerData?.campaignId || centerData?.goalAmmount > 0) && (
                    <>
                      <div className={style.maincampaignbutton}>
                        <div className={`mt-3 ${style.doantiondata}`}>
                          <div className={`my-2 ${style.amountdonationn}`}>
                            ${centerDetail?.totalAmount || 0} USD raised of $
                            {(centerDetail?.goalAmount || centerData?.goalAmmount || 0).toLocaleString()}
                          </div>
                          <ProgressBar
                            variant="info"
                            animated
                            now={centerDetail?.percentage || 0}
                            className={style.progressbar}
                          />

                          {!donationList && (
                            <div className=" p-5 text-center">
                              <h5> No Data Found </h5>
                            </div>
                          )}
                        </div>
                        <p>How Can I Help?</p>
                        <div className={style.innercampaignbutton}>
                          <button onClick={() => handleNavigate()}>Create a Supporting Campaign</button>
                        </div>

                        <div className={style.innercampaignbutton}>
                          <button onClick={handleShare}>Share This Campaign</button>
                        </div>
                      </div>

                    </>
                  )}
                  <div className={style.amountdonationmain}>
                    <div className={style.labellinkmaindonate}>
                      Enter a custom donation amount
                    </div>

                    <div className={style.customAmountInputdonation}>
                      <span className={style.currencydonation}>$</span>

                      <input
                        type="text"
                        value={amount}
                        placeholder="Enter custom amount"
                        onChange={(e) => setSelectedAmount(e.target.value)}
                        className={style.inputboxtextdonation}
                      />
                    </div>
                    <div className={style.labellinkemailmaindonate}>Enter Name</div>

                    <div className={style.customAmountInput}>
                      <input
                        type="text"
                        placeholder="Full name"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        className={style.informationinputdonationmain}
                      />
                    </div>

                    <div className={style.labellinkemailmaindonate}>Enter Email</div>

                    <div className={style.customAmountInput}>
                      <input
                        type="email"
                        placeholder="Email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={style.informationinputdonationmain}
                        disabled={isLoggedIn} // Disable if logged in
                      />
                    </div>
                    <div className={style.labellinkemailmaindonate}>
                      Add a comment (optional)
                    </div>
                    <div className={style.customAmountInput}>
                      <input
                        placeholder="Write your comment..."
                        value={usercomment}
                        onChange={(e) => setUserComment(e.target.value)}
                        className={style.informationinputdonationmain}
                        rows={3}
                      />
                    </div>
                    <div className={style.consentcheckbox}>
                      <input
                        type="checkbox"
                        id="invoiceConsent"
                        checked={sendInvoiceConsent}
                        onChange={(e) => setSendInvoiceConsent(e.target.checked)}
                        className={style.invoiceCheckbox}
                      />
                      <label htmlFor="invoiceConsent" className={style.labelinvoice}>
                        I would like to receive the tax deduction receipt.
                      </label>
                    </div>
                  </div>
                  <div className={style.paymentformmaindonation}>
                    <div className={style.paymentFormdonationcamp}>
                      <div className={style.donationpaymentmaincamp}>
                        <h3>Choose a donation frequency</h3>
                        <div className={style.donateradiomaincamp}>
                          <div
                            className={
                              selectedFrequency === "1"
                                ? style.selectedLabel2main
                                : style.labeldonatemain
                            }
                          >
                            <div className={style.donationlabelmain}>
                              <label className={style.labelcontent}>
                                <input
                                  type="radio"
                                  name="frequency"
                                  value="1"
                                  checked={selectedFrequency === "1"}
                                  onChange={handleFrequencyChange}
                                />

                                <span>OneTime</span>
                              </label>
                            </div>
                          </div>

                          <div
                            className={
                              selectedFrequency === "month"
                                ? style.selectedLabel2main
                                : style.labeldonate2main
                            }
                          >
                            <div className={style.donationlabelmain}>
                              <label className={style.labelcontent}>
                                <input
                                  type="radio"
                                  name="frequency"
                                  value="month"
                                  checked={selectedFrequency === "month"}
                                  onChange={handleFrequencyChange}
                                />

                                <span>Monthly</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className={style.donationbuttoncontainermaincamp}>
                          <div className={style.smallscreenabutton}>
                            <button onClick={handleDonate}>
                              <img src="/logosstripe.png"></img>
                            </button>
                          </div>
                        </div>
                        {/* <div className={style.donationbuttonpaypalcontainer} key={selectedFrequency}>
                          <div className={style.smallscreenabutton}>
                            <PayPalScriptProvider
                              options={{
                                "client-id":
                                  "Adpk1iHPoLLJks3J32GLO598fGKUobHCZWHn89fhQ1Xp9_TgO_4kYrSE9VHKMQTLCHkd7emdnl7LvxmM",
                                "enable-funding": "venmo,paypal",
                                "disable-funding": "card,paylater",
                                ...(selectedFrequency === "month" && { vault: true })
                              }}>
                              <PayPalButtons
                                style={{
                                  color: "white",
                                  shape: "pill",
                                }}
                                className={style.paypalbutton}
                                onClick={(data, actions) => {
                                  if (!amount) {
                                    toast.error("Please select a donation amount.");
                                    return actions.reject();
                                  }
                                  if (!email) {
                                    toast.error("Please enter your email address.");
                                    return actions.reject();
                                  }
                                  if (!fullName) {
                                    toast.error("Please enter your full name.");
                                    return actions.reject();
                                  }
                                  return actions.resolve();
                                }}
                                createOrder={
                                  selectedFrequency === "1"
                                    ? (data, actions) => {
                                        return actions.order.create({
                                          purchase_units: [
                                            {
                                              amount: {
                                                value: amount.replace(/,/g, ""),
                                              },
                                            },
                                          ],
                                        });
                                      }
                                    : undefined
                                }
                                createSubscription={
                                  selectedFrequency === "month"
                                    ? (data, actions) => {
                                        const cleanAmount = amount.replace(/,/g, "");
                                        const planId = PAYPAL_PLAN_IDS[cleanAmount];
                                        if (!planId) {
                                          toast.error(
                                            "PayPal recurring payments are only supported for predefined tiers ($40, $50, $70, $100, $200). For custom monthly donations, please use Credit Card."
                                          );
                                          return actions.reject();
                                        }
                                        return actions.subscription.create({
                                          plan_id: planId,
                                        });
                                      }
                                    : undefined
                                }
                                onApprove={(data, actions) => {
                                  if (selectedFrequency === "month") {
                                    return actions.subscription.get().then((details) => {
                                      const transactionId = data.subscriptionID;
                                      const approvedEmail = details.subscriber?.email_address || email;
                                      
                                      if (approvedEmail) {
                                        localStorage.setItem("email", approvedEmail);
                                      }
                                      
                                      dispatch(
                                        paypalSubscription({
                                          amount: amount,
                                          email: approvedEmail,
                                          fullName: fullName,
                                          _id: Id,
                                          centerId: centerData?._id || centerData?.id,
                                          subscriptionId: transactionId,
                                          status: "ACTIVE",
                                          usercomment: usercomment,
                                          books: [
                                            {
                                              name: "Love Smarter, Not Harder",
                                              link: "https://hbcuhopeproject.org/love-smarter-not-harder/"
                                            }
                                          ],
                                        })
                                      )
                                        .then(() => {
                                          navigate(
                                            `/success?success=true&transactionId=${transactionId}&centerId=${centerData?._id || centerData?.id}`
                                          );
                                        })
                                        .catch((error) => {
                                          console.error("Error saving subscription:", error);
                                          toast.error("Subscription successful, but failed to save in database.");
                                        });
                                    });
                                  } else {
                                    return actions.order.capture().then(function (details) {
                                      const transactionId = details.id;
                                      const approvedEmail = details.payer.email_address || email;

                                      if (approvedEmail) {
                                        localStorage.setItem("email", approvedEmail);
                                      }

                                      dispatch(
                                        paypalPayment({
                                          amount: amount,
                                          email: approvedEmail,
                                          fullName: fullName,
                                          _id: Id,
                                          centerId: centerData?._id || centerData?.id,
                                          status: details.status,
                                          usercomment: usercomment,
                                          books: [
                                            {
                                              name: "Love Smarter, Not Harder",
                                              link: "https://hbcuhopeproject.org/love-smarter-not-harder/"
                                            }
                                          ],
                                        })
                                      )
                                        .then(() => {
                                          navigate(
                                            `/success?success=true&transactionId=${transactionId}&centerId=${centerData?._id || centerData?.id}`
                                          );
                                        })
                                        .catch((error) => {
                                          console.error("Error saving transaction:", error);
                                          toast.error("Payment successful, but failed to save transaction.");
                                        });
                                    });
                                  }
                                }}
                                onError={(err) => {
                                  toast.error("An error occurred during payment processing.");
                                  console.error("PayPal Error:", err);
                                }}
                              />
                            </PayPalScriptProvider>
                          </div>
                        </div> */}


                        <div style={{ display: "flex", gap: "10px" }}>
                          <div
                            className={style.donationbuttoncontainermain}
                            style={{ flex: "1" }}
                          >
                            <div className={style.smallscreenabutton}>
                              <button onClick={handleShare}>Share</button>
                            </div>
                          </div>
                          <div style={{ flex: "1" }}>
                            <Pray centerId={centerid} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={style.maincampaigngift}>
                    <h4>Your Free Gift – Love Smarter, Not Harder</h4>
                    <div className={style.innercampaigngift}>

                      <img src="/newBook1.png" alt="Love Smarter, Not Harder" />
                      <p className={style.innergiftptext}>This booklet offers timeless relationship principles that benefit college students and young adults alike. More than simply preventing an unexpected pregnancy, it's about strengthening family formation by helping young singles make wise relationship choices and lay the foundation for strong marriages and thriving families”</p>

                      {/* <Row>

                        <Col xl={3}>
                          <img src="/book.png"  className="w-80"/>
                        </Col>
                        <Col xl={9}>
                          <p className={style.innergiftptext}>Years of research brought unsettling discoveries instead of the clarity I once expected. What began as a simple search for understanding revealed deeper contradictions and difficult truths. In my final commentary, I share these revelations openly, knowing they may challenge what many have long believed.</p>
                        </Col>


                      </Row> */}
                    </div>
                    <div className={style.innergiftpromo}>
                      <p>Get a copy for the young single in your life</p>
                    </div>
                  </div>


                  <Row className={style.desktopcomment}>
                    <Col md={12} xl={12} lg={7} className="p-0">
                      {comments?.length > 0 && (
                        <div className={style.mainsectioncomment}>
                          <h1>Comments</h1>
                          <div className={style.maincomment}>
                            <div className={style.innersection}>
                              {comments?.map((item, index) => (
                                <div key={index}>
                                  {/* Dynamically render center name and amount */}
                                  <h2>
                                    <span>{item?.fullName}</span> - $
                                    {item?.amount} USD
                                  </h2>
                                  {/* Render comment content dynamically */}
                                  <p>{item.usercomment}</p>
                                  <hr />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                    </Col>
                  </Row>
                  <Row className={style.phonecomment}>
                    <Col md={12} xl={12} lg={7} className="p-0">
                      {comments?.length > 0 && (
                        <div className={style.mainsectioncomment}>
                          <h1>Comments</h1>
                          <div className={style.maincomment}>
                            <div className={style.innersection}>
                              {comments?.map((item, index) => (
                                <div key={index}>
                                  {/* Dynamically render center name and amount */}
                                  <h2>
                                    <span>{item?.fullName}</span> - $
                                    {item?.amount} USD
                                  </h2>
                                  {/* Render comment content dynamically */}
                                  <p>{item.usercomment}</p>
                                  <hr />
                                </div>
                              ))}


                            </div>
                          </div>
                        </div>
                      )}

                    </Col>

                  </Row>




                  {/* ✅ Show only for HBCU centers on mobile/tablet */}
                  {centerData?.centerName?.includes("The HBCU") && (
                    <div className="text-center mt-4 d-block d-lg-none">
                      <img
                        src="/Giftcards.svg"
                        className="w-100"
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <VideoPlayer
          showVideoPlayer={showVideoPlayer}
          setShowVideoPlayer={setShowVideoPlayer}
          videoUrl={videoUrl}
        // isdata={isdata}
        />
        <TransactionStatus
          showTransactionStatus={showTransactionStatus}
          setShowTransactionStaus={setShowTransactionStaus}
        />
        <ShareModal
          show={showShareModal}
          onHide={closeShareModal}
          shareUrl={shareConfig.shareUrl}
          title={shareConfig.title}
          description={shareConfig.description}
          hashtags={shareConfig.hashtags}
          pageId={shareConfig.pageId}
        />
      </div>
    </>
  );
};

export default Donation;
